<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Row>
        <Spin v-if="showLoading" fix />
        <Form ref="form" :label-width="110" :model="formFields" :rules="ruleValidate">
          <div style="display:flex; width: 100%">
            <i-col span="14" class="align-left" style="padding-right: 10px; border-right: 1px dotted #e8eaec">
              <FormItem label="用户类型:" prop="isFresh">
                <RadioGroup v-model="formFields.isFresh">
                  <Radio :label="0" :true-value="0">
                    老用户
                  </Radio>
                  <Radio :label="1" :true-value="1">
                    新用户
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="账号名:" prop="name">
                <Input v-model="formFields.name" placeholder="请输入账号名, 账号名必须唯一..." size="small" />
              </FormItem>
              <FormItem label="姓名:" prop="realName">
                <Input v-model="formFields.realName" placeholder="请输入会员姓名..." size="small" />
              </FormItem>
              <FormItem label="手机号:" prop="mobile">
                <Input v-model="formFields.mobile" placeholder="请输入手机号码..." size="small" />
              </FormItem>
              <FormItem label="身份证:" prop="identityCard">
                <Input v-model="formFields.identityCard" placeholder="请输入身份证..." size="small" />
              </FormItem>
              <FormItem label="照片可更改次数:" prop="threshold">
                <Input v-model="formFields.threshold" placeholder="请输入照片可更改次数..." size="small" />
              </FormItem>
              <FormItem label="性别:" prop="gender">
                <RadioGroup v-model="formFields.gender">
                  <Radio :label="1" :true-value="1">
                    男
                  </Radio>
                  <Radio :label="2" :true-value="2">
                    女
                  </Radio>
                </RadioGroup>
              </FormItem>

              <FormItem label="用户角色:" prop="type">
                <RadioGroup v-model="formFields.type" @on-change="handleRoleTypeChange">
                  <Radio :label="0" :true-value="0">
                    普通会员
                  </Radio>
                  <Radio :label="1" :true-value="1">
                    后台管理员
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem v-if="roleType === 1" label="用户权限:" prop="roles">
                <Select
                  v-model="formFields.roles"
                  :label-in-value="true"
                  size="small"
                  multiple
                  :loading="selectLoading"
                  :max-tag-count="2"
                  @on-change="handleRoleChange"
                >
                  <Option v-for="(option, index) in roleOptions" :key="index" :value="option.id" :label="option.name" />
                </Select>
              </FormItem>
              <FormItem v-if="roleType === 1 && !isSuperAdmin" label="绑定车库:" prop="adminParkings">
                <Select
                  v-model="formFields.adminParkings"
                  size="small"
                  multiple
                  :loading="selectLoading"
                  :max-tag-count="2"
                >
                  <Option v-for="(option, index) in parkingOptions" :key="index" :value="option.id" :label="option.name" />
                </Select>
              </FormItem>
            </i-col>
            <i-col span="10" style="padding-left: 10px;">
              <div>
                <label style="margin-right: 10px;">头像上传:</label>
                <RadioGroup v-model="photoMode" type="button" size="small" @on-change="handeModeChange">
                  <Radio label="本地上传" :true-value="1" />
                  <Radio label="在线拍照" :true-value="2" />
                </RadioGroup>
              </div>
              <div style="margin-top: 15px;">
                <Upload
                  v-if="photoMode === '本地上传'"
                  ref="upload"
                  class="upload"
                  :before-upload="handleUpload"
                  :show-upload-list="true"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  accept=".jpg,.png,.jpeg"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  type="drag"
                  action="//jsonplaceholder.typicode.com/posts/"
                >
                  <div class="upload-icon">
                    <Icon type="ios-cloud-upload-outline" size="52" />
                    点击或者拖拽文件上传...
                  </div>
                </Upload>
                <span v-if="blob != null && photoMode === '本地上传'" style="font-size: 7pt;">上传文件：{{ blob.name }}</span>
                <VueCamera
                  v-if="photoMode ==='在线拍照'"
                  ref="camera"
                  :enabled="photoMode ==='在线拍照'"
                  capture="photo"
                  @onPhoto="onPhotoTaken"
                  @onReady="uploadPhoto"
                />
              </div>
            </i-col>
          </div>
        </Form>
      </Row>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="showLoading"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import VueCamera from '@/components/camera'
import { applyObject } from '@/utils/util'
export default {
  name: 'UserDialog',
  components: {
    VueCamera
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      file: null,
      loadingStatus: false,
      showLoading: false,
      selectLoading: false,
      defaultList: [],
      roleOptions: [],
      parkingOptions: [],
      photoMode: '本地上传',
      submit: false,
      roleType: 0,
      isSuperAdmin: false,
      isPartner: false,
      formFields: {
        id: this.id,
        isFresh: 0,
        type: 0,
        name: '',
        realName: '',
        mobile: '',
        identityCard: '',
        gender: 1,
        roles: [],
        adminParkings: [],
        threshold: 1,
        isTemporary: false
      },
      blob: null
    }
  },
  computed: {
    adminRoles() {
      return ['超级管理员', '系统管理员']
    },
    partnerRoles() {
      return ['分成合伙人', '授权合伙人']
    },
    ruleValidate() {
      return {
        name: [
          { required: true, message: '账号不能为空!', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '姓名不能为空!', trigger: 'blur' }
        ],
        mobile: [
          { required: true, type: 'string', message: '手机号不合法!', pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }
        ],
        identityCard: [
          { type: 'string', message: '身份证不合法!', pattern: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/, trigger: 'blur' }
        ],
        roles: [
          { required: true, type: 'array', min: 1, message: '至少选择一个角色', trigger: 'change' }
        ],
        adminParkings: [
          { required: !this.isSuperAdmin && !this.isPartner, type: 'array', min: 1, message: '至少选择一个绑定车库', trigger: 'change' }
        ]
      }
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑用户' : '添加新用户'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.$refs.form.resetFields()
      this.roleType = 0
      this.photoMode = '本地上传'
      this.showLoading = false
      if (this.action && this.id) {
        this.showLoading = true
        request({
          url: this.action + '/' + this.id || '',
          method: 'get'
        }).then(res => {
          this.showLoading = false
          // this.formFields = res.data
          const data = res.data
          console.log(data, this.formFields)
          applyObject(data, this.formFields)
          this.formFields = { ...this.formFields, isFresh: data.isFresh ? 1 : 0 }
          this.roleType = this.formFields.type
          delete this.formFields.registrationTime
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.showLoading = false
        })
      }

      this.selectLoading = true
      request({
        url: this.$config.apiContextPath + '/role?visible=1',
        method: 'get'
      }).then(res => {
        this.roleOptions = res.data.content
        this.selectLoading = false
      }).catch(error => {
        console.log(error)
        this.roleOptions = []
        this.selectLoading = false
      })

      request({
        url: this.$config.apiContextPath + '/parking',
        method: 'get'
      }).then(res => {
        this.parkingOptions = res.data.content
        this.selectLoading = false
      }).catch(error => {
        console.log(error)
        this.parkingOptions = []
        this.selectLoading = false
      })
    }
  },
  mounted() {
  },
  methods: {
    handleRoleChange: function(selections) {
      this.isSuperAdmin = false
      for (var roleIndex in selections) {
        if (this.adminRoles.includes(selections[roleIndex].label)) {
          this.isSuperAdmin = true
          this.formFields.adminParkings = []
          break
        }
      }
      this.isPartner = false
      for (var index in selections) {
        if (this.partnerRoles.includes(selections[index].label)) {
          this.isPartner = true
          break
        }
      }
    },
    handleRoleTypeChange: function(label) {
      this.roleType = label
      if (label === 0) {
        this.formFields.adminParkings = []
      }
    },
    handeModeChange: function(label) {
    },
    getFormData: function(id) {
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submit = true
          const isNew = this.formFields.id === 0
          if (isNew && !this.blob) {
            this.$Notice.error({
              title: '表单填写错误',
              desc: '请上传用户图片!'
            })
            this.submit = false
            return
          }

          var data = new FormData()
          if (this.blob) {
            data.append('file', this.blob, 'photo.png')
          }

          const self = this
          Object.keys(this.formFields).forEach(function(key) {
            const fieldValue = self.formFields[key]
            if (fieldValue instanceof Array && fieldValue.length === 0) {
              return
            }
            (fieldValue || fieldValue === 0) && data.append(key, fieldValue)
          })
          data.append('isTemporary', false)
          request({
            url: this.action + (isNew ? '/register' : ('/' + this.id)),
            method: 'post',
            data: data
          }).then(res => {
            this.loadingStatus = false
            // this.formFields = res.data
            this.$Notice.success({
              title: '数据保存成功',
              desc: '用户 `' + this.formFields.name + '` 保存成功!'
            })
            this.submit = false
            this.closeModal(true)
          }).catch(() => {
            // this.$Notice.error({
            //   title: '服务器数据请求失败',
            //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
            // })
            this.loadingStatus = false
            this.submit = false
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.formFields = {
        id: 0,
        name: '',
        realName: '',
        mobile: '',
        identityCard: '',
        gender: 1,
        type: 0,
        roles: [],
        adminParkings: []
      }
      this.isSuperAdmin = false
      this.isPartner = false
      this.roleType = 0
      this.roleOptions = []
      this.blob = null
      this.$emit('on-close', changed)
    },
    handleSuccess(res, file) {
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '图片文件 "' + file.name + '" 格式不正确，请选择jpg或者png文件格式.'
      })
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小超出上限',
        desc: '图片文件 "' + file.name + '" 大小超出上限，2M.'
      })
    },
    handleUpload(file) {
      this.blob = file
      return false
    },
    handleBeforeUpload() {
    },
    uploadPhoto(blob) {
    },
    onPhotoTaken(blob) {
      this.blob = blob
    }
  }
}
</script>

<style lang="less" scoped>
  .upload {
    .upload-icon {
      width: 270px;
      height: 205px;
      align-items: center;
      justify-content: center;
      display: flex;
      i {
        color: #3399ff;
      }
    }
  }
  .camera-note {
    color: #fd7e14;
    font-size: 8pt;
    margin-top: 10px;
  }
</style>
